import { AuthGate } from '@/features/auth/auth-gate'
import { PharmacyShell } from '@/features/shell/pharmacy-shell'
export function ProtectedLayout() {
  return (
    <AuthGate>
      <PharmacyShell />
    </AuthGate>
  )
}
